import { ASSESSMENT_SLUG } from "core/consts";
import { AssessmentSlug, Auction } from "core/types";
import { createContext, useContext } from "react";

type PatientInfoContextType = {
  auction: Auction | null;
};
type PatientInfoSlugContextType = {
  assessmentSlug: AssessmentSlug | undefined;
  auctionId: number;
  patientId: number;
};

export const PatientInfoContext = createContext<PatientInfoContextType>({
  auction: null,
});

export function usePatientInfoContext(): PatientInfoContextType {
  return useContext(PatientInfoContext);
}

const defaultPatientInfoSlugContext = {
  assessmentSlug: ASSESSMENT_SLUG.INFO,
  auctionId: -1,
  patientId: -1,
};

export const PatientInfoSlugContext = createContext<PatientInfoSlugContextType>(
  defaultPatientInfoSlugContext,
);

export function usePatientInfoSlug(): PatientInfoSlugContextType {
  const context = useContext(PatientInfoSlugContext);
  if (!context || context === defaultPatientInfoSlugContext) {
    throw new Error(
      "usePatientInfoSlug must be used within a PatientInfoContext",
    );
  }
  return context;
}
